import BillFromPosReport from './BillFromPosReport';
import BillReport from './BillReport';
import DeliveryReport from './DeliveryReport';
import DispatchReport from './DispatchReport';
import FinanceReport from './FinanceReport';
import FinancialStateReport from './FinancialStateReport';
import InventoryStatusReport from './InventoryStatusReport';
import OrderListReport from './OrderListReport';
import ProductSheetReport from './ProductSheetReport';

const Reports = {
  dispatch: DispatchReport, //Despacho
  bill: BillReport, //Factura
  bill_pos: BillFromPosReport, //Factura From POS
  delivery: DeliveryReport, //Albarán
  financial_state: FinancialStateReport, //Estado financiero
  finance: FinanceReport, //Finanza
  product_sheet: ProductSheetReport, //Ficha de producto
  inventory_status: InventoryStatusReport, //Estado de inventario
  order_list: OrderListReport, //Listado de Órdenes
}
export default Reports
